// contextmenu.directive.js
// import { DirectiveBinding } from 'vue';

export default {
    beforeMount(el, binding) {
        el.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            // 获取绑定的菜单数据
            const menuData = binding.value;
            // 显示自定义菜单
            showCustomMenu(el, menuData, e);
        });
    }
};

function showCustomMenu(el, menuData, e) {
    // 创建自定义菜单的DOM结构
    const menu = document.createElement('a-menu');
    menu.style.position = 'absolute';
    menu.style.left = `${e.clientX}px`;
    menu.style.top = `${e.clientY}px`;
    menu.style.background = '#eeefff';
    menu.style.padding = '8px';
    menu.style.border = '1px solid #dedede';
    menu.style.borderRadius = '4px';
    menu.style.fontSize = '12px';
    menuData.forEach((item) => {
        const menuItem = document.createElement('a-menu-item');
        menuItem.textContent = item.label;
        menuItem.style.cursor = 'pointer';
        menuItem.addEventListener('click', item.onClick);
        menu.appendChild(menuItem);
    });
    // 将菜单添加到body
    document.body.appendChild(menu);
}